import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';
@Injectable({
    providedIn: 'root'
})

export class PostHubService {
    private API = environment.apiURL;
    constructor(private http: HttpClient) { }
    getBotDetailsByMerchantId(merchantId) {
        return this.http.get<any>(this.API + '/merchants/' + merchantId + '/bots', { observe: 'response' })
    }

    public requestMultipleBotConfigurationById(idArray): Observable<any[]> {
        let urls = []
        idArray.forEach(element => {
            urls.push(this.http.get<any>(this.API + '/bots/' + element.bot_id + '/configuration', { observe: 'response' }))
        });
        // Observable.forkJoin (RxJS 5) changes to just forkJoin() in RxJS 6
        return forkJoin(urls);
    }
    getPostByBotId(botId, postListType, limit?: number, offset?:number, start_time?:string, end_time?: string, post_type?: string){
        const params = new URLSearchParams();
        if(limit) params.append('limit', limit.toString());
        if(offset) params.append('offset', offset.toString());
        if (start_time) params.append('start_time', start_time);
        if (end_time) params.append('end_time', end_time);
        if (post_type) params.append('post_type', post_type);
        if(postListType === 'Published')
          return this.http.get<any>(`${this.API}/bots/${botId}/posts?${params.toString()}`, {observe : 'response'});
        else 
         return this.http.get<any>(this.API + '/bots/' + botId + '/scheduled-posts', { observe: 'response' });
    }
    getMerchantPost(botId: string, start_time?:string, end_time?: string, post_type?: string){
        const params = new URLSearchParams();
        if (start_time) params.append('start_time', start_time);
        if (end_time) params.append('end_time', end_time);
        if (post_type) params.append('post_type', post_type);
        return this.http.get<any>(`${this.API}/bots/${botId}/posts/export?${params.toString()}`, {observe : 'response'});

    }
    getPostDetailsByPostId(botId, postId, isSchedule){
        if(!isSchedule)
          return this.http.get<any>(this.API + '/bots/' + botId +'/posts/' + postId, {observe: 'response'});
        else 
          return this.http.get<any>(this.API + '/bots/' + botId +'/scheduled-posts/' + postId, {observe: 'response'});
    }
    uploadPostMedia(fileType, botId){
        return this.http.post<any>(`${this.API}/bots/${botId}/posts/media`, {type : fileType})
    }
    uploadFileToS3(file, s3Creds){
        const formData = new FormData();
        const fields = s3Creds.upload_details.s3_fields;
        if (fields.Key) formData.append('Key', fields.Key);
        if (fields.bucket) formData.append('bucket', fields.bucket);
        if (fields.Policy) formData.append('Policy', fields.Policy);
        if (fields['X-Amz-Algorithm']) formData.append('X-Amz-Algorithm', fields['X-Amz-Algorithm']);
        if (fields['X-Amz-Credential']) formData.append('X-Amz-Credential', fields['X-Amz-Credential']);
        if (fields['X-Amz-Date']) formData.append('X-Amz-Date', fields['X-Amz-Date']);
        if (fields['X-Amz-Signature']) formData.append('X-Amz-Signature', fields['X-Amz-Signature']);
        if (fields['X-Amz-Security-Token']) formData.append('X-Amz-Security-Token', fields['X-Amz-Security-Token']);
        if (file && file.type) formData.append('Content-Type', file.type);
        if (file) formData.append('file', file);
        const headers = new HttpHeaders();
        this.http.post<any>(s3Creds.upload_details.url, formData, {headers}).subscribe((res)=> console.log(res), (err)=> console.log(err));
    }
    postFeed(reqBody, botId, isSchedulePost){
        if(!isSchedulePost)
           return this.http.post<any>(`${this.API}/bots/${botId}/posts`, reqBody)
        else 
          return this.http.post<any>(`${this.API}/bots/${botId}/scheduled-posts`, reqBody)
    }

    deletePost(postId, botId, postType) {
        if(postType === 'Published'){
            return this.http.delete<any>(`${this.API}/bots/${botId}/posts/${postId}`, { observe: 'response' }); 
        }
        return this.http.delete<any>(`${this.API}/bots/${botId}/scheduled-posts/${postId}`, { observe: 'response' }); 
    }
    getPollVoters(postId: string, botId: string) {
        return this.http.get<any>(`${this.API}/bots/${botId}/posts/${postId}/custom-responses`);  
    }
}
